<template>
  <div class="m-grid__item m-grid__item--fluid m-wrapper">
    <bread-crumb>
      <span slot="title">New Business</span>
      <ul class="m-subheader__BreadCrumbs m-nav m-nav--inline" slot="links">
        <li class="m-nav__item">
          <router-link :to="{ name: 'services', params:params }" class="m-nav__link">
            <span class="m-nav__link-text">
              Services
            </span>
          </router-link>
        </li>
        <li class="m-nav__separator">
          -
        </li>
        <li class="m-nav__item">
          <router-link :to="{ name: 'sbp', params:params }" class="m-nav__link">
            <span class="m-nav__link-text">
              SBP
            </span>
          </router-link>
        </li>
      </ul>
    </bread-crumb>
    <div class="m-content">
      <div class="row">
        <div class="col-md-12">
          <div class="m-portlet">
            <div class="m-portlet__head">
              <div class="m-portlet__head-caption">
                <div class="m-portlet__head-title">
                  <span class="m-portlet__head-icon m--hide">
                    <i class="la la-gear"></i>
                  </span>
                  <h3 class="m-portlet__head-text">
                    Enter Business Details
                  </h3>
                </div>
              </div>
            </div>
            <div class="m-form m-form--fit m-form--label-align-right m-form--group-seperator-dashed">
              <div class="m-portlet__body m--padding-bottom-25">
                <div class="form-group m-form__group row">
                  <div class="col-lg-4">
                    <label>Business Name</label>
                    <input type="text" id="businessName" name="businessName" class="form-control m-input" v-model="business.businessName" data-vv-as="business name" v-validate="'required'">
                    <small v-show="errors.has('businessName')" class="m--font-danger">{{ errors.first('businessName') }}</small>
                  </div>
                  <div class="col-lg-4">
                    <label>Email</label>
                    <input type="email" id="email" name="email" class="form-control m-input" v-validate="'required|email'" v-model="business.email">
                    <small v-show="errors.has('email')" class="m--font-danger">{{ errors.first('email') }}</small>
                  </div>
                  <div class="col-lg-4">
                    <label>Phone Number</label>
                    <input type="text" id="phoneNo" name="phoneNo" class="form-control m-input" v-model="business.phoneNo" v-validate="'required|digits:10'" data-vv-as="phone number">
                    <small v-show="errors.has('phoneNo')" class="m--font-danger">{{ errors.first('phoneNo') }}</small>
                  </div>
                </div>
                <div class="form-group m-form__group row">
                  <div class="col-lg-4">
                    <label>Pin Number</label>
                    <input type="text" id="pinNo" name="pinNo" class="form-control m-input" v-model="business.pinNo" data-vv-as="PIN number" v-validate="'required'">
                    <small v-show="errors.has('pinNo')" class="m--font-danger">{{ errors.first('pinNo') }}</small>
                  </div>
                  <div class="col-lg-4">
                    <label>VAT Number</label>
                    <input type="text" id="vatNo" name="vatNo" class="form-control empty" v-model="business.vatNo">
                    <small v-show="errors.has('vatNo')" class="m-font-danger">{{ errors.first('vatNo') }}</small>
                  </div>
                  <div class="col-lg-4">
                    <label>Plot Number</label>
                    <input type="text" id="plotNo" name="plotNo" class="form-control empty" v-model="business.plotNo">
                    <small v-show="errors.has('plotNo')" class="m--font-danger">{{ errors.first('plotNo') }}</small>
                  </div>
                </div>
                <div class="form-group m-form__group row">
                  <div class="col-lg-4">
                    <label>Business Activity</label>
                    <input type="text" id="businessActivity" name="businessActivity" class="form-control empty" v-model="business.businessActivity" data-vv-as="business activity" v-validate="'required'">
                    <small v-show="errors.has('businessActivity')" class="m--font-danger">
                      {{ errors.first('businessActivity') }}
                    </small>
                  </div>
                  <div class="col-lg-4">
                    <label>Sub-county</label>
                    <select type="text" id="subCounty" name="subCounty" v-validate="'required'" data-vv-as="sub-county name" class="form-control m-input" v-model="business.subCountyId">
                      <option v-for="subCounty in subCounties" :value="subCounty.id" :key="subCounty.id">
                        {{ subCounty.name }}
                      </option>
                    </select>
                    <small v-show="errors.has('subCounty')" class="m--font-danger">{{ errors.first('subCounty') }}</small>
                  </div>
                   <div class="col-lg-4">
                    <label>P.O. Box</label>
                    <input type="text" id="poBox" name="poBox" class="form-control m-input" v-model="business.poBox" data-vv-as="P.O. Box" v-validate="'required'">
                    <small v-show="errors.has('poBox')" class="m--font-danger">{{ errors.first('poBox') }}</small>
                  </div>
                </div>
                <div class="form-group m-form__group row">
                  <div class="col-lg-4">
                    <label>Postal Code</label>
                    <input type="text" id="postalCode" name="postalCode" class="form-control m-input" v-model="business.postalCode" data-vv-as="postal code" v-validate="'required'">
                    <small v-show="errors.has('postalCode')" class="m--font-danger">{{ errors.first('postalCode') }}</small>
                  </div>
                  <div class="col-lg-4">
                    <label>Pysical Address</label>
                    <input type="text" id="physicalAddress" name="physicalAddress" class="form-control empty" v-model="business.physicalAddress" data-vv-as="physical address" v-validate="'required'">
                    <small v-show="errors.has('physicalAddress')" class="m--font-danger">
                      {{ errors.first('physicalAddress') }}
                    </small>
                  </div>
                </div>
              </div>
              <div class="m-portlet__foot m-portlet__no-border m-portlet__foot--fit">
                <div class="m-form__actions m-form__actions--solid">
                  <div class="row">
                    <div class="col-lg-12">
                      <button type="save" class="btn btn-success m--pull-right" @click="createBusiness" v-html="btnText">
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import api from "../../../api";
import helper from "../../../helpers";
import BreadCrumb from "../../partials/BreadCrumb";

export default {
  name: "AddBusiness",
  components: {
    BreadCrumb
  },
  data() {
    return {
      subCounties: [],
      params: this.$route.params,
      btnText: '<i class="fa fa-save"></i> Save Business',
      business: {
        countyId: this.$route.params.countyId,
        token: this.$store.state.token || window.localStorage.getItem("token"),
        subCountyId: "",
        businessName: "",
        pinNo: "",
        idNo: JSON.parse(window.localStorage.getItem("user")).idNo,
        vatNo: "",
        poBox: "",
        postalCode: "",
        phoneNo: "",
        email: "",
        plotNo: "",
        physicalAddress: ""
      }
    };
  },
  methods: {
    toggleLoading() {
      this.btnText =
        this.btnText === '<i class="fa fa-save"></i> Save Business'
          ? "Loading..."
          : '<i class="fa fa-save"></i> Save Business';
    },
    createBusiness() {
      this.$validator
        .validateAll()
        .then(valid => {
          if (valid) {
            const txType = "register-business";
            this.toggleLoading();
            api
              .request(txType, this.business)
              .then(response => {
                this.toggleLoading();
                if (response.data.status === "00") {
                  helper
                    .successAlert("Business created successfully")
                    .then(() => {
                      this.$router.push({ name: "sbp" });
                    });
                } else {
                  helper.errorAlert(response.data.message);
                }
              })
              .catch(error => {
                this.toggleLoading();
                helper.errorAlert(
                  "We could not establish a connection to the server. Please try again later"
                );
                console.log(error);
              });
          }
        })
        .then(() => {
          console.log("Validation failed");
        });
    }
  },
  created: function() {
    const txType = "get-sub-counties";
    api
      .request(txType, {
        token: this.business.token,
        countyId: this.params.countyId
      })
      .then(response => {
        if (response.data.status === "00") {
          this.subCounties = response.data.subCounties;
        }
      });
    this.$store.commit("SET_LOADING", { status: false });
  }
};
</script>



// WEBPACK FOOTER //
// src/components/services/sbp/AddBusiness.vue